﻿// Site global javascript
import * as jQuery from 'jquery/dist/jquery';
window.$ = window.jQuery = jQuery;
import 'jquery-validation/dist/jquery.validate';

import 'bootstrap/dist/js/bootstrap';
import { debounce } from './debounce';
import 'jquery-ui/dist/jquery-ui';

window.debounce = debounce;


// Css
import '../Content/datatables.css';
import '../Content/scss/app.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery-ui/dist/themes/base/jquery-ui.css';
import 'jquery-ui/dist/themes/base/theme.css';
import '../Content/ext/fontawesome/css/solid.css';
import '../Content/ext/fontawesome/css/fontawesome.css';



$(function() {
    // Add tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Check if dom-element exists with id "menu_hrcount" which should exist in the menu
    // if the user is CSU or SectraAdmin. In that case we need to fetch how many requests there
    // are to handle and insert it into that dom-element.
    if ($('#menu_hrcount').length > 0) {
        fetch('/api/v1/requestaccesses/getcount', { credentials: 'include' })
            .then(response => response.json())
            .then(data => $('#menu_hrcount').html(data));
    }
});